'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @since 2016-11-05 10:13
 * @author vivaxy
 */

var BEGIN = exports.BEGIN = 'begin';
var END = exports.END = 'end';


//////////////////
// WEBPACK FOOTER
// ./~/impression.js/dist/configs/events.js
// module id = 41
// module chunks = 4